import { render } from "./CRMWhatsappProductFollowupSummaryView.vue?vue&type=template&id=47ee73be&scoped=true"
import script from "./CRMWhatsappProductFollowupSummaryView.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappProductFollowupSummaryView.vue?vue&type=script&lang=js"

import "./CRMWhatsappProductFollowupSummaryView.vue?vue&type=style&index=0&id=47ee73be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ee73be"]])

export default __exports__